import { Injectable } from '@angular/core';
import { Expense } from '../../models/expense';
import { ResourceService } from './resource';
import { HttpClient } from '@angular/common/http';
import { CacheService } from '../cache';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ExpenseService extends ResourceService<Expense> {

  constructor(
    protected http: HttpClient,
    protected cache: CacheService
  ) {
    super(http, cache, 'expenses');
  }


  createExpense(payload: Expense) {
    return this.http.post<any>(`${this.endpoint}`, payload)
      .pipe(map((resp: any) => {
        this.cache.remove(`${this.endpoint}`);
        this.cache.remove(`${this.endpoint}`);
        return resp;
      }))
  }

  getAllExpenses(params: any) {
    return this.http.get<any>(`${this.endpoint}`, { params })
      .pipe(map((resp: any) => {
        this.cache.remove(`${this.endpoint}`);
        this.cache.remove(`${this.endpoint}`);
        return resp;
      }))
  }

  downloadExpense(id: string, params: any) {
    return this.http.get<any>(`${this.endpoint}/download/${id}`, { params })
      .pipe(map((resp: any) => {
        this.cache.remove(`${this.endpoint}`);
        this.cache.remove(`${this.endpoint}`);
        return resp;
      }))
  }
}
